import api from './api';

export interface NeighborhoodProfile {
  _id?: string;
  name: string;
  riskLabel: 'Adventurous' | 'Daring' | 'Prudent' | 'Neutral';
  capital: number;
  financingType: 'bank_broker' | 'hard_money';
  outcome: 'cashflow' | 'equity' | 'brrrr';
  propertyType: 'single_family' | 'duplex' | 'triplex' | 'multifamily';
  preferredState?: string;
  preferredMetro?: string;
  minDealPower?: number;
  minYield?: number;
  createdAt?: string;
}

export const neighborhoodProfileService = {
  async list(page = 1, limit = 10) {
    const res = await api.get('/neighborhood-profiles', { params: { page, limit } });
    return res.data as { items: NeighborhoodProfile[]; total: number; page: number; limit: number };
  },

  async create(payload: NeighborhoodProfile) {
    const res = await api.post('/neighborhood-profiles', payload);
    return res.data as NeighborhoodProfile;
  },
};

